// Brazilian Portuguese (pt-BR) — route /br/open-your-gym.
// True Brazilian localization (NOT European Portuguese) — always "academia".
// Keys override the English master copy carried as component defaults.
export default {
  // SEO
  "seo.title": "Abra Sua Academia — Direto do Fabricante | YANRE FITNESS EUROPE",
  "seo.description": "De estúdios personalizados a grandes academias — equipamentos profissionais YANRE direto do fabricante, consultoria de projeto, logística internacional e pós-venda com garantia de fábrica.",

  // Header / nav
  "nav.Why Fitness": "Por Que Fitness",
  "nav.Why YANRE": "Por Que a YANRE",
  "nav.How It Works": "Como Funciona",
  "nav.Real Projects": "Projetos Reais",
  "nav.visitWebsite": "Visitar Site",
  "header.cta": "Começar Projeto",

  // Hero (exact approved BR copy)
  "hero.label": "Abra Sua Academia",
  "hero.line1": "Construa sua academia.",
  "hero.line2a": "Compre direto do",
  "hero.line2b": "fabricante.",
  "hero.copy": "De estúdios personalizados a grandes academias comerciais — equipamentos profissionais YANRE, consultoria personalizada para o projeto, suporte logístico internacional e pós-venda direto do fabricante.",
  "hero.ctaPrimary": "Começar Meu Projeto de Academia",
  "hero.ctaSecondary": "Falar com um Especialista",
  "hero.trust.0": "Direto do fabricante",
  "hero.trust.1": "Consultoria de projeto",
  "hero.trust.2": "Logística internacional",
  "hero.trust.3": "Garantia de fábrica",

  // Marquee
  "marquee.Precision": "Precisão",
  "marquee.Performance": "Performance",
  "marquee.Confidence": "Confiança",
  "marquee.Engineering": "Engenharia",
  "marquee.Since 1997": "Desde 1997",

  // CTA strips
  "strip.1": "Pronto para falar sobre o seu projeto?",
  "strip.2": "Sabe do que precisa? Vamos conversar.",
  "strip.3": "Já viu o suficiente? Comece seu projeto.",
  "strip.cta": "Começar Projeto",

  // Section labels
  "label.Why Invest in Fitness": "Por Que Investir no Fitness",
  "label.Fitness Market Proof": "Prova do Mercado Fitness",
  "label.New to Fitness? That's OK.": "Novo no Fitness? Sem Problema.",
  "label.Factory Direct": "Direto do Fabricante",
  "label.Factory Direct Purchase Process": "Processo de Compra Direto do Fabricante",
  "label.Featured Equipment": "Equipamentos em Destaque",
  "label.Engineered Differently": "Engenharia Diferente",
  "label.Built Around Your Business": "Feito em Torno do Seu Negócio",
  "label.Why YANRE FITNESS": "Por Que a YANRE FITNESS",
  "label.The Founder": "O Fundador",
  "label.YANRE Gyms Around the World": "Academias YANRE pelo Mundo",
  "label.International Logistics": "Logística Internacional",
  "label.After-Sales & Warranty": "Pós-Venda e Garantia",
  "label.Start Your Project": "Comece Seu Projeto",
  "label.Milestones": "Marcos",
  "label.Engineering Philosophy": "Filosofia de Engenharia",

  // WhatsApp
  "wa.title": "WhatsApp",
  "wa.subtitle": "Falar com um Especialista",

  // Footer
  "footer.contact": "Contato",
  "footer.legal": "Legal",
  "footer.privacy": "Política de Privacidade",
  "footer.cookies": "Política de Cookies",
  "footer.terms": "Termos",
  "footer.visit": "Visite o site da YANRE FITNESS EUROPE",

  // Form — steps
  "step.1": "Projeto",
  "step.2": "Espaço",
  "step.3": "Investimento",
  "step.4": "Contato",
  "step.5": "Necessidades do Projeto",
  "step.6": "Logística",
  "step.7": "Compra",
  "step.8": "Seu Papel",
  "step.9": "Localização",
  "step.10": "Contato",
  "step.11": "Informações Finais",
  "form.progress": "Etapa",
  "form.title1": "Monte o projeto",
  "form.title2": "da sua academia.",
  "form.subtitle": "Conte para nós o que você está planejando. Nós ajudamos a montar a solução de equipamentos certa.",
  "form.intro.sub1": "4 PASSOS RÁPIDOS.",
  "form.intro.sub2": "UMA SOLUÇÃO COMPLETA PARA SUA ACADEMIA.",
  "form.intro.support": "Conte para nós sobre o seu projeto em apenas 4 passos simples. Nossa equipe vai entender suas necessidades e ajudar você a construir a solução certa — com fornecimento direto da fábrica da YANRE FITNESS China, consultoria profissional e suporte pós-venda.",
  "form.intro.minute": "1 MINUTO PARA CONCLUIR",
  "form.back": "Voltar",
  "form.continue": "Continuar",
  "form.submit": "Receber Meu Projeto de Academia",
  "form.sending": "Enviando…",

  // Form — questions
  "q.projectType": "O que melhor descreve o seu projeto?",
  "q.franchiseStatus": "Você já está ligado a uma franquia de academia?",
  "q.locationStatus": "Você já tem um espaço para o projeto?",
  "q.facilityArea": "Qual é a área útil aproximada disponível?",
  "q.projectStage": "Em que estágio está o seu projeto?",
  "q.openingTimeline": "Quando você pretende inaugurar seu projeto?",
  "q.investmentBand": "Qual é a sua faixa de investimento estimada? (USD)",
  "q.investmentHint": "Uma estimativa é suficiente. Isso nos ajuda a recomendar a solução certa para o seu projeto.",
  "q.projectNeed": "O que você precisa para o seu projeto?",
  "q.projectNeedHint": "Selecione todas as opções que se aplicam.",
  "q.equipmentListStatus": "Você já tem uma lista de equipamentos?",
  "q.logisticsPreference": "Como você quer lidar com a logística internacional?",
  "q.purchaseMethod": "Como você planeja comprar seus equipamentos?",
  "q.competitorComparison": "Você está comparando outras marcas de equipamentos?",
  "q.competitorBrands": "Quais marcas você está considerando?",
  "q.decisionRole": "Qual é o seu papel neste projeto?",
  "q.country": "País do projeto",
  "q.city": "Cidade",
  "q.firstName": "Nome",
  "q.lastName": "Sobrenome",
  "q.company": "Empresa / Nome da Academia (opcional)",
  "q.email": "E-mail",
  "q.phone": "WhatsApp / Telefone",
  "q.preferredContact": "Forma de contato preferida",
  "q.notes": "Há mais algo que devemos saber sobre o seu projeto?",
  "q.optional": "Opcional",
  "q.selectCountry": "Selecione o país",

  // Form — option labels (canonical values unchanged)
  "opt.commercial-gym": "Projeto de Academia Completo",
  "opt.boutique-gym": "Academia Boutique",
  "opt.pt-studio": "Estúdio de Personal Training",
  "opt.home-gym": "Academia Residencial Privada",
  "opt.residential-gym": "Academia de Condomínio / Residencial",
  "opt.hotel-resort": "Fitness de Hotel / Resort",
  "opt.corporate-gym": "Academia Corporativa",
  "opt.sports-facility": "Centro Esportivo / de Performance",
  "opt.franchise": "Franquia de Academia",
  "opt.other": "Outro",
  "opt.own-franchise": "Sim — já tenho / opero uma franquia",
  "opt.acquiring-franchise": "Sim — estou adquirindo uma franquia",
  "opt.evaluating-franchise": "Estou avaliando oportunidades de franquia",
  "opt.independent": "Não — estou explorando o mercado de academias por conta própria",
  "opt.confirmed": "Sim — local confirmado",
  "opt.negotiating": "Negociando um local",
  "opt.looking": "Ainda procurando um local",
  "opt.up-to-100": "Até 100 m²",
  "opt.100-250": "100–250 m²",
  "opt.250-500": "250–500 m²",
  "opt.500-1000": "500–1.000 m²",
  "opt.1000-2000": "1.000–2.000 m²",
  "opt.2000-plus": "Mais de 2.000 m²",
  "opt.exploring": "Explorando oportunidades de investimento",
  "opt.initial-planning": "Planejamento inicial",
  "opt.business-plan": "Plano de negócios / planejamento de investimento",
  "opt.location-selected": "Local selecionado",
  "opt.architecture": "Arquitetura / design",
  "opt.construction": "Obra / reforma",
  "opt.ready-to-purchase": "Pronto para comprar os equipamentos",
  "opt.expansion": "Nova unidade / expansão",
  "opt.within-2": "Em até 2 meses",
  "opt.2-4": "2–4 meses",
  "opt.4-6": "4–6 meses",
  "opt.6-12": "6–12 meses",
  "opt.12-plus": "Mais de 12 meses",
  "opt.up-to-50k": "Menos de USD 50.000",
  "opt.50-150k": "USD 50.000–150.000",
  "opt.150-300k": "USD 150.000–300.000",
  "opt.300-500k": "USD 300.000–500.000",
  "opt.500k-1m": "USD 500.000–1M",
  "opt.1m-plus": "Mais de USD 1M",
  "opt.complete-equipment": "Equipamentos completos para academia",
  "opt.strength": "Máquinas de musculação",
  "opt.cardio": "Equipamentos de cardio",
  "opt.full-project-help": "Preciso de ajuda com o projeto completo",
  "opt.have-list": "Sim — já tenho uma lista de equipamentos",
  "opt.need-review": "Parcialmente — tenho uma seleção inicial",
  "opt.need-list": "Não — preciso da ajuda da YANRE",
  "opt.yanre-coordination": "Quero a coordenação logística da YANRE",
  "opt.own-partner": "Já tenho um parceiro logístico",
  "opt.compare-both": "Quero comparar as duas opções",
  "opt.need-guidance": "Preciso de orientação antes de decidir",
  "opt.direct": "Direto do fabricante",
  "opt.dealer": "Revendedor local de equipamentos para academia",
  "opt.distributor": "Distribuidor / importador",
  "opt.comparing": "Comparando diferentes opções de compra",
  "opt.researching": "Ainda pesquisando fornecedores",
  "opt.yes": "Sim",
  "opt.no": "Não",
  "opt.owner": "Proprietário / Fundador",
  "opt.investor": "Investidor",
  "opt.partner": "Sócio",
  "opt.director": "Diretor / Executivo",
  "opt.manager": "Gerente de academia",
  "opt.procurement": "Compras / Suprimentos",
  "opt.architect": "Arquiteto / Designer",
  "opt.consultant": "Consultor",
  "opt.trainer": "Personal Trainer",
  "opt.whatsapp": "WhatsApp",
  "opt.phone": "Ligação telefônica",
  "opt.email": "E-mail",

  // Form — validation
  "err.projectType": "Selecione o que você planeja montar.",
  "err.franchiseStatus": "Informe a sua situação em relação a franquias.",
  "err.locationStatus": "Selecione a situação do seu local.",
  "err.facilityArea": "Selecione a área aproximada da academia.",
  "err.projectStage": "Selecione o estágio do seu projeto.",
  "err.openingTimeline": "Selecione o prazo previsto para a inauguração.",
  "err.investmentBand": "Selecione o seu investimento estimado em equipamentos.",
  "err.projectNeed": "Selecione pelo menos uma necessidade do projeto.",
  "err.equipmentListStatus": "Selecione a situação da sua lista de equipamentos.",
  "err.logisticsPreference": "Selecione uma preferência de logística.",
  "err.purchaseMethod": "Selecione o seu plano de compra.",
  "err.competitorComparison": "Conte para nós se você está comparando marcas.",
  "err.decisionRole": "Selecione o seu papel neste projeto.",
  "err.country": "Selecione o país do projeto.",
  "err.city": "Informe a cidade do projeto.",
  "err.firstName": "Informe o seu nome.",
  "err.lastName": "Informe o seu sobrenome.",
  "err.email": "Informe um e-mail válido.",
  "err.phone": "Informe o seu WhatsApp / telefone.",
  "err.preferredContact": "Selecione a sua forma de contato preferida.",
  "err.privacyConsent": "Aceite o consentimento de privacidade para enviar o seu projeto.",
  "err.submit": "Ocorreu um erro ao enviar o seu projeto. Tente novamente.",

  // Form — consent & success
  "consent.privacy": "Concordo que a YANRE FITNESS EUROPE processe minhas informações para falar comigo sobre este projeto.",
  "consent.marketing": "Também quero receber novidades e ofertas da YANRE FITNESS EUROPE de vez em quando. (Opcional)",
  "success.title1": "Projeto Recebido",
  "success.body": "Obrigado. Um especialista da YANRE FITNESS EUROPE vai analisar o seu projeto e falar com você pelo canal de contato preferido.",
  "success.reference": "Referência",

  // ===== Section copy =====
  "wi.h1a": "Procurando o seu próximo negócio?",
  "wi.h1b": "Pense em academias.",
  "wi.fitnessCol": "Negócio de Academia",
  "wi.retailCol": "Varejo Tradicional",
  "wi.f1": "Mensalidades recorrentes",
  "wi.f2": "Sem estoque de mercadorias",
  "wi.f3": "Sem reposição diária",
  "wi.f4": "Acesso pré-pago / recorrente",
  "wi.f5": "Potencial de operação enxuta",
  "wi.f6": "Gestão digital",
  "wi.f7": "Equipamentos = ativo produtivo de longo prazo",
  "wi.r1": "Vender todos os dias",
  "wi.r2": "Gerenciar estoque",
  "wi.r3": "Recompras constantes",
  "wi.r4": "Receita de transação em transação",
  "wi.r5": "Operação com estoque",
  "wi.r6": "Maior complexidade operacional",
  "wi.r7": "O estoque precisa girar continuamente",
  "wi.note": "Uma comparação estrutural de modelos de negócio — não é um julgamento de outros setores.",
  "mp.s1": "Receita do mercado fitness europeu em 2025",
  "mp.s2": "Alunos de academias na Europa em 2025",
  "mp.s3": "Crescimento médio global da receita do setor fitness em 2024",
  "mp.s4": "Margem EBITDA mediana entre os operadores do estudo de benchmark da HFA referenciado",
  "mp.opsLabel": "Grandes operadoras estão expandindo",
  "mp.o1": "Novos alunos das 20 maiores operadoras da Europa em 2025",
  "mp.o2": "Receita combinada das 20 maiores operadoras da Europa em 2025",
  "mp.o3": "Grandes operações de fusão e aquisição no fitness europeu em 2025",
  "mp.src": "Fontes: Health & Fitness Association · EuropeActive / Deloitte. Dados de benchmark do setor — não garantem resultados individuais.",
  "nf.h1a": "Você não precisa vir do",
  "nf.h1b": "mercado fitness.",
  "nf.b1": "Você traz o investimento e a visão de negócio.",
  "nf.b2": "Nós ajudamos a estruturar a parte de equipamentos do projeto.",
  "fd.h1a": "Elimine os intermediários.",
  "fd.h1b": "Mas não o suporte.",
  "fd.tradLabel": "Modelo Tradicional",
  "fd.directLabel": "YANRE Direto do Fabricante",
  "fd.t1": "Fabricante",
  "fd.t2": "Distribuidor / Importador",
  "fd.t3": "Revendedor / Varejista",
  "fd.t4": "Cliente",
  "fd.customer": "Cliente",
  "fd.trust": "Seu contrato de equipamentos e seus pagamentos são feitos diretamente com a YANRE FITNESS, a fabricante, na China.",
  "fd.supportLabel": "Comprar direto da fábrica não significa estar sozinho",
  "fd.s1": "Consultoria personalizada",
  "fd.s2": "Orientação técnica",
  "fd.s3": "Seleção de equipamentos",
  "fd.s4": "Suporte ao projeto",
  "fd.s5": "Coordenação logística opcional",
  "fd.s6": "Suporte pós-venda",
  "fd.s7": "Garantia de fábrica",
  "pp.h1a": "Um processo claro.",
  "pp.h1b": "Do projeto ao pós-venda.",
  "pp.1.t": "Briefing do projeto",
  "pp.1.b": "O cliente apresenta a área, o conceito, o investimento e o cronograma.",
  "pp.2.t": "Consultoria YANRE",
  "pp.2.b": "Seleção de equipamentos, orientação técnica e configuração do projeto.",
  "pp.3.t": "Contrato com a fábrica",
  "pp.3.b": "Proposta final e pedido oficial de equipamentos diretamente com a YANRE FITNESS.",
  "pp.4.t": "Pagamento de 30% à fábrica",
  "pp.4.b": "Entrada padrão paga diretamente à YANRE FITNESS; o pedido entra em produção.",
  "pp.5.t": "Produção",
  "pp.5.b": "Fabricação e preparação dos equipamentos.",
  "pp.6.t": "Pagamento de 70% à fábrica",
  "pp.6.b": "Saldo padrão pago diretamente à YANRE FITNESS após a produção e antes do embarque, conforme o contrato oficial.",
  "pp.7.t": "Envio internacional",
  "pp.7.b": "O cliente pode usar seu próprio operador logístico ou solicitar a coordenação logística.",
  "pp.8.t": "Pós-venda",
  "pp.8.b": "Suporte contínuo e garantia de fábrica após a entrega.",
  "pp.payTitle": "100% dos pagamentos de equipamentos são feitos diretamente à YANRE FITNESS.",
  "pp.paySub": "Nenhum pagamento de equipamentos é feito a agentes, consultores ou intermediários.",
  "pp.disclaimer": "Estrutura de pagamento padrão apresentada. As condições comerciais e de pagamento finais são definidas no contrato oficial de compra da YANRE FITNESS.",
  "fe.h1a": "Feitos para performar.",
  "fe.h1b": "Construídos para serem vistos.",
  "fe.tagline": "Seus equipamentos fazem parte da sua marca.",
  "fe.i0.cat": "Musculação com Carga Selecionável",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "Máquinas de musculação com carga selecionável, projetadas para o uso profissional diário.",
  "fe.i1.cat": "Plate Loaded",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "Máquinas plate loaded construídas em torno do movimento natural.",
  "fe.i2.cat": "Dupla Função",
  "fe.i2.series": "C4D Dupla Função",
  "fe.i2.stmt": "Duas estações em um só espaço — máxima densidade de treino.",
  "fe.i3.cat": "Cardio Comercial",
  "fe.i3.series": "Cardio Comercial",
  "fe.i3.stmt": "Cardio feito para ambientes comerciais que não param.",
  "dd.h1a": "A diferença",
  "dd.h1b": "está nos detalhes.",
  "dd.0.t": "Engenharia original",
  "dd.0.s": "Design desenvolvido pela YANRE.",
  "dd.1.t": "Design patenteado",
  "dd.1.s": "Design de equipamento original e patenteado.",
  "dd.2.t": "Construção da estrutura",
  "dd.2.s": "Engenharia de estruturas e tubos em close-up.",
  "dd.3.t": "Estrutura curva",
  "dd.3.s": "Geometria de estrutura moldada em torno do movimento.",
  "dd.4.t": "Estofamento e almofadas",
  "dd.4.s": "Estofamento, costura e acabamento profissionais.",
  "dd.5.t": "Sistema de cabos / roldanas / guias",
  "dd.5.s": "Componentes de movimento de precisão.",
  "dd.6.t": "Biomecânica",
  "dd.6.s": "Pivôs e trajetórias de movimento projetados em torno do corpo.",
  "dd.7.t": "Construção de nível comercial",
  "dd.7.s": "Feito para durabilidade e uso profissional diário.",
  "bt.0": "Academia Comercial",
  "bt.1": "Clube Fitness Premium",
  "bt.2": "Academia Boutique",
  "bt.3": "Estúdio de Personal Training",
  "bt.4": "Estúdio de Força / Performance",
  "bt.5": "Centro de Treinamento Funcional",
  "bt.6": "Academia Residencial Privada Profissional",
  "bt.7": "Academia de Condomínio",
  "bt.8": "Hotel / Resort",
  "bt.9": "Fitness Corporativo",
  "bt.10": "Unidade Franqueada",
  "wy.h1a": "Projetado com experiência.",
  "wy.h1b": "Construído para performance.",
  "wy.p1.t": "Fabricação",
  "wy.p1.b": "Produção própria de sistemas de musculação de nível comercial — projetados e fabricados pela YANRE, não montados a partir de projetos de terceiros.",
  "wy.p2.t": "Engenharia e Biomecânica",
  "wy.p2.b": "Design original desde 1997, com mais de 200 patentes em engenharia de equipamentos e biomecânica do movimento.",
  "wy.p3.t": "Durabilidade comercial",
  "wy.p3.b": "Equipamentos projetados para o uso profissional diário, certificados pelas normas CE, TÜV e ISO.",
  "wy.p4.t": "Desenvolvimento de produto",
  "wy.p4.b": "Um portfólio liderado pela fabricante — da 73 Tough Series às linhas plate loaded, máquinas de dupla função e cardio comercial.",
  "wy.p5.t": "Experiência internacional",
  "wy.p5.b": "Presente em academias profissionais em mais de 110 países, com mais de 34.950 projetos entregues no mundo — direto da fábrica na China.",
  "wy.proof0": "Desde 1997",
  "wy.proof1": "Mais de 200 patentes",
  "wy.proof2": "Mais de 110 países",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "Mais de 34.950 projetos",
  "fo.navFactory": "A Fábrica",
  "fo.navFounder": "O Homem Por Trás da Máquina",
  "fo.h1a": "O Homem",
  "fo.h1b": "Por Trás",
  "fo.h1c": "da Máquina.",
  "fo.role": "Fundador e Designer-Chefe",
  "fo.body": "Atleta, engenheiro e fundador da YANRE. Desde 1997, ele constrói máquinas para pessoas que valorizam engenharia acima de marketing.",
  "fo.quote": "“Para entender a máquina, é preciso entender o homem por trás dela.”",
  "fo.st1.t": "O Começo",
  "fo.st1.b": "Em 1991, George Yang ainda não era fundador — era técnico, reparando equipamentos de academia para a equipe nacional de atletas da China. Reparar revelou a verdade; ele mesmo treinava nas máquinas para sentir exatamente onde falhavam.",
  "fo.st2.t": "O Problema",
  "fo.st2.b": "Mesmo as “melhores” marcas do mundo tinham falhas — soldas fracas, ângulos ruins e designs que ignoravam o corpo humano. As limitações que ele viu moldaram uma forma completamente nova de pensar equipamentos.",
  "fo.st3.t": "A Fundação",
  "fo.st3.b": "Em 1997, ele parou de corrigir os erros dos outros e definiu o seu próprio padrão — fundando a Yangrui Fitness em Pequim, nome dado em homenagem ao filho. O nome evoluiu de Yangrui para Yanre e depois YR; o padrão nunca mudou.",
  "fo.st4.t": "O Engenheiro",
  "fo.st4.b": "Ele recusa concessões em materiais: aço Q235 qualificado com mínimo de 3 mm, barras 30CrMnSiA, cames e roldanas de POM de baixo atrito e cabos importados do Japão com classificação de 1.400 kg. “Eu mesmo treino nestas máquinas.”",
  "fo.st5.t": "O Designer",
  "fo.st5.b": "Sua filosofia é limpa e minimalista — design não é aparência, é funcionamento. A YANRE projeta em vez de copiar; a 73 Series foi a primeira do mundo com trajetórias de movimento independentes, convergentes e divergentes.",
  "fo.st6.t": "A Visão",
  "fo.st6.b": "Uma fábrica de artesãos, não um armazém de caixas — pedido mínimo de uma unidade, personalização real e suporte pensado para o décimo ano de uma academia, não só para o primeiro dia. Um parceiro, não um chefe.",
  "fo.m1.t": "Experiência técnica inicial",
  "fo.m1.b": "Técnico da equipe nacional de atletas da China.",
  "fo.m2.t": "Fundação da YANRE",
  "fo.m2.b": "Yangrui Fitness fundada em Pequim.",
  "fo.m3.t": "A 73 Series",
  "fo.m3.b": "Primeira do mundo com trajetórias independentes, convergentes e divergentes.",
  "fo.pqA": "“Fazemos produtos com",
  "fo.pqHeart": "coração",
  "fo.pqB": ", e fazemos produtos com",
  "fo.pqStandard": "padrão",
  "fo.pqEnd": ".“",
  "fo.c1.t": "Materiais",
  "fo.c1.b": "Aço Q235, mínimo de 3 mm. Cames de POM. Cabos de 1.400 kg.",
  "fo.c2.t": "Biomecânica",
  "fo.c2.b": "Trajetórias de movimento projetadas em torno do corpo humano.",
  "fo.c3.t": "Durabilidade",
  "fo.c3.b": "Feito para durar mais de 10 anos de uso profissional.",
  "fo.c4.t": "Padrão",
  "fo.c4.b": "ISO 20957 como ponto de partida — nunca como limite máximo.",
  "cc.h1a": "Academias reais.",
  "cc.h1b": "Negócios reais.",
  "cc.h1c": "YANRE real.",
  "cc.case0.title": "Visual premium. Instalação profissional.",
  "cc.case1.title": "Layout clean. Instalação sólida.",
  "cc.case2.title": "Estilo funcional. Equipamento profissional.",
  "cc.videoPending": "Vídeo completo do projeto disponível sob solicitação",
  "lg.h1a": "Seus equipamentos. Seu destino.",
  "lg.h1b": "Sua escolha.",
  "lg.option": "Opção",
  "lg.o1.t": "Use seu parceiro logístico",
  "lg.o1.b": "Trabalhe com o operador logístico em quem você já confia. Preparamos o seu pedido para exportação e coordenamos com o seu parceiro.",
  "lg.o2.t": "Deixe a coordenação conosco",
  "lg.o2.b": "Solicite a coordenação logística da YANRE conforme o escopo contratado — da fábrica na China ao porto de destino.",
  "lg.f1": "Fábrica",
  "lg.f2": "Exportação",
  "lg.f3": "Frete marítimo",
  "lg.f4": "Porto de destino",
  "lg.disclaimer": "Desembaraço aduaneiro, impostos, taxas e serviços de última milha só estão incluídos quando expressamente contratados.",
  "lg.cta": "Incluir logística no meu projeto",
  "as.h1a": "O relacionamento não termina",
  "as.h1b": "quando o contêiner sai.",
  "as.1.t": "Garantia de fábrica",
  "as.1.b": "Suporte de garantia do fabricante para os seus equipamentos.",
  "as.2.t": "Suporte técnico",
  "as.2.b": "Assistência técnica direta, ligada às pessoas por trás dos equipamentos.",
  "as.3.t": "Suporte de peças de reposição",
  "as.3.b": "Suporte de peças no nível do fabricante para as suas máquinas.",
  "as.4.t": "Assistência pós-venda",
  "as.4.b": "Assistência pós-venda contínua após a entrega.",

  // Cookie consent & policy
  "ck.title": "Suas escolhas de privacidade",
  "ck.desc": "Usamos cookies opcionais de análise e publicidade somente com o seu consentimento. Você pode alterar ou retirar sua escolha a qualquer momento.",
  "ck.acceptAll": "Aceitar Tudo",
  "ck.reject": "Rejeitar Não Essenciais",
  "ck.manage": "Gerenciar Preferências",
  "ck.save": "Salvar Preferências",
  "ck.necessary": "Necessários",
  "ck.necessaryDesc": "Necessários para o funcionamento do site. Sempre ativos.",
  "ck.analytics": "Análise",
  "ck.analyticsDesc": "Estatísticas anônimas de uso que nos ajudam a melhorar este site.",
  "ck.advertising": "Publicidade",
  "ck.advertisingDesc": "Usados para medir campanhas e exibir publicidade relevante.",
  "ck.alwaysOn": "Sempre ativos",
  "ck.prefsTitle": "Preferências de Cookies",
  "ck.policy": "Política de Cookies",
  "ck.privacy": "Política de Privacidade",
  "footer.cookiePrefs": "Preferências de Cookies",
  "cp.title": "Política de Cookies",
  "cp.updated": "Última atualização: julho de 2026",
  "cp.intro": "Esta página explica como a YANRE FITNESS EUROPE usa cookies e tecnologias semelhantes neste site, e como você pode controlá-los.",
  "cp.s1t": "O que armazenamos",
  "cp.s1b": "Quando você faz uma escolha de consentimento, armazenamos apenas essa escolha (necessários, análise, publicidade) no armazenamento local do seu navegador. Ela não contém informações pessoais e serve apenas para lembrar sua preferência entre visitas.",
  "cp.s2t": "Categorias de cookies",
  "cp.s3t": "Google Tag Manager e Modo de Consentimento",
  "cp.s3b": "Este site carrega um contêiner do Google Tag Manager com o Modo de Consentimento v2 do Google. Todo armazenamento opcional (análise e publicidade) é definido como \"denied\" por padrão e só é ativado após o seu consentimento explícito. Nenhuma tag de análise ou publicidade está instalada diretamente neste site.",
  "cp.s4t": "Gerenciando seu consentimento",
  "cp.s4b": "Você pode alterar ou retirar seu consentimento a qualquer momento pelo link \"Preferências de Cookies\" no rodapé do site. A retirada tem efeito imediato.",
  "cp.s5t": "Contato",
  "cp.privacyT": "Privacidade",
  "cp.privacyB": "Nossa Política de Privacidade completa está sendo finalizada. Para qualquer dúvida ou solicitação sobre seus dados pessoais, fale conosco pelo e-mail acima.",
  "cp.back": "Voltar ao Início",

  "q.fullName": "Nome Completo",
  "opt.upgrade-expand": "Upgrade / Ampliação de uma Academia Existente",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — pt-BR =====
  "pts.seo.title": "Estúdio de Personal Trainer — Equipamentos para Academia Profissionais | YANRE FITNESS",
  "pts.seo.description": "Monte seu próprio estúdio de treinamento com equipamentos profissionais YANRE, direto do fabricante. Pacotes iniciais inteligentes, planejamento de espaço e suporte direto da fábrica.",
  "pts.nav.talk": "Falar com um Especialista",
  "pts.header.cta": "Montar Meu Estúdio",
  "pts.hero.label": "Estúdio de Personal Trainer",
  "pts.hero.line1": "Seu Estúdio.",
  "pts.hero.line2": "Seus Clientes.",
  "pts.hero.line3": "Seu Negócio.",
  "pts.hero.subhead": "Monte seu estúdio de treinamento profissional com a YANRE.",
  "pts.hero.copy": "Do seu primeiro estúdio privado a um espaço premium de personal training — equipamentos para academia de nível profissional, planejamento inteligente de espaço e suporte direto do fabricante.",
  "pts.hero.ctaPrimary": "Montar Meu Estúdio",
  "pts.hero.ctaSecondary": "Falar com um Especialista",
  "pts.hero.trust.0": "Qualidade Comercial",
  "pts.hero.trust.1": "Direto do Fabricante",
  "pts.hero.trust.2": "Garantia de Fábrica",
  "pts.hero.trust.3": "Suporte Logístico",
  "pts.journey.label": "A Transição",
  "pts.journey.h2a": "De Personal Trainer",
  "pts.journey.h2b": "a Dono de Estúdio.",
  "pts.journey.copy": "Treinar clientes na academia de outra pessoa constrói o negócio dela. Seu próprio estúdio constrói o seu — seu espaço, seus relacionamentos com clientes, sua marca, seu patrimônio. A independência começa com uma sala e os equipamentos certos.",
  "pts.journey.0": "Personal Trainer",
  "pts.journey.1": "Seu Próprio Estúdio",
  "pts.journey.2": "Seus Próprios Clientes",
  "pts.journey.3": "Sua Própria Marca",
  "pts.journey.4": "Seu Próprio Negócio",
  "pts.journey.direct": "Direto do Fabricante.",
  "pts.journey.directCopy": "Monte seu estúdio com equipamentos profissionais comprados diretamente da YANRE — o fabricante que projeta e produz cada máquina.",
  "pts.journey.note": "Sem promessas, sem atalhos — apenas a estrutura para transformar sua arte em um negócio que é seu.",
  "pts.pkg.label": "Duas Formas de Começar",
  "pts.pkg.h2a": "Comece com inteligência.",
  "pts.pkg.h2b": "Cresça do seu jeito.",
  "pts.pkg.intro": "Um estúdio profissional começa com um pacote de equipamentos escolhido com cuidado — e cresce com o tempo. Cada composição é personalizada para o seu espaço, metodologia de treino e nível de investimento.",
  "pts.pkg.tag": "Pacote",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "Tudo o que você precisa para abrir um estúdio de treinamento privado e profissional.",
  "pts.pkg.starter.i0": "Primeiro estúdio",
  "pts.pkg.starter.i1": "Personal trainers",
  "pts.pkg.starter.i2": "Espaços pequenos",
  "pts.pkg.starter.i3": "Treino 1 para 3",
  "pts.pkg.starter.i4": "Treino semiprivado",
  "pts.pkg.starter.concept": "Uma combinação selecionada com cuidado de máquinas de musculação essenciais, equipamentos funcionais e pesos livres.",
  "pts.pkg.starter.cta": "Montar Meu Estúdio Starter",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "Uma estrutura profissional completa para um negócio premium de personal training.",
  "pts.pkg.studiopro.i0": "Personal trainers estabelecidos",
  "pts.pkg.studiopro.i1": "Estúdios premium",
  "pts.pkg.studiopro.i2": "Maior capacidade de clientes",
  "pts.pkg.studiopro.i3": "Treino em pequenos grupos",
  "pts.pkg.studiopro.i4": "Treino de performance",
  "pts.pkg.studiopro.concept": "Uma combinação mais completa de máquinas de musculação, equipamentos funcionais, pesos livres e cardio.",
  "pts.pkg.studiopro.cta": "Montar Meu Studio Pro",
  "pts.pkg.idealFor": "Ideal para",
  "pts.pkg.conceptLabel": "Conceito de equipamentos",
  "pts.pkg.quote": "Peça sua proposta de projeto",
  "pts.pkg.note": "Sem preços fixos online — cada estúdio recebe orçamento como um projeto, montado para o seu espaço, metodologia e nível de investimento.",
  "pts.eq.label": "Feito para Treinar de Verdade",
  "pts.eq.h2a": "Qualidade comercial.",
  "pts.eq.h2b": "Feito para uso profissional diário.",
  "pts.eq.copy": "As mesmas linhas de equipamentos que atendem academias comerciais — estruturas projetadas, movimento patenteado e durabilidade testada em fábrica — dimensionadas de forma inteligente para um estúdio de treinamento privado.",
  "pts.eq.strength": "Musculação",
  "pts.eq.functional": "Treino Funcional",
  "pts.eq.freeweights": "Pesos Livres",
  "pts.eq.benches": "Bancos e Racks",
  "pts.eq.cable": "Estações de Cabo",
  "pts.eq.cardio": "Cardio",
  "pts.eq.alt.strength": "Equipamentos de musculação profissionais YANRE para estúdios de personal training",
  "pts.eq.alt.functional": "Equipamentos de treino funcional YANRE para academias e estúdios profissionais",
  "pts.eq.alt.freeweights": "Equipamentos profissionais de pesos livres YANRE para estúdios de personal training",
  "pts.eq.alt.benches": "Bancos e racks profissionais YANRE para estúdios de personal training",
  "pts.eq.alt.cable": "Estações de cabo profissionais YANRE para estúdios de personal training",
  "pts.eq.alt.cardio": "Equipamentos de cardio profissionais YANRE para estúdios de personal training",
  "pts.space.label": "Planejamento de Espaço",
  "pts.space.h2a": "Seu espaço.",
  "pts.space.h2b": "Seu projeto.",
  "pts.space.copy": "Não existem dois estúdios iguais. A seleção de equipamentos e o layout são desenhados em torno da sua realidade — não um pacote fixo de catálogo.",
  "pts.space.f0": "Área disponível",
  "pts.space.f1": "Metodologia de treino",
  "pts.space.f2": "Número de clientes simultâneos",
  "pts.space.f3": "Nível de investimento",
  "pts.space.f4": "Compra Direta da Fábrica",
  "pts.space.f4d": "Equipamentos profissionais YANRE sem camadas desnecessárias de revendedores.",
  "pts.space.f5": "Estúdio Pronto para Operar",
  "pts.space.f5d": "Equipamentos profissionais, layout inteligente e um conceito completo de estúdio pronto para o negócio.",
  "pts.space.cta": "Começar Meu Projeto de Estúdio",
  "pts.direct.label": "Direto do Fabricante",
  "pts.direct.h2a": "Sem intermediários.",
  "pts.direct.h2b": "Sem concessões.",
  "pts.direct.copy": "A YANRE é o fabricante — projeta e produz seus próprios equipamentos profissionais desde 1997. Seu projeto, seu contrato de equipamentos e sua garantia ficam diretamente com a fábrica que constrói suas máquinas.",
  "pts.direct.p0": "Equipamentos de nível comercial",
  "pts.direct.p1": "Relacionamento direto com o fabricante",
  "pts.direct.p2": "Garantia com respaldo da fábrica",
  "pts.direct.p3": "Suporte logístico internacional",
  "pts.direct.p4": "Consultoria de projeto",
  "pts.direct.p5": "Suporte pós-venda",
  "pts.process.label": "Como Funciona",
  "pts.process.h2a": "Um processo claro.",
  "pts.process.h2b": "Da ideia ao dia da inauguração.",
  "pts.process.1.t": "Consultoria",
  "pts.process.1.b": "Entendemos você, seu espaço, seu conceito e seu nível de investimento.",
  "pts.process.2.t": "Projeto",
  "pts.process.2.b": "Juntos, definimos a seleção de equipamentos e o layout do estúdio.",
  "pts.process.3.t": "Pedido — 30%",
  "pts.process.3.b": "Confirme o projeto e inicie a produção com um pagamento de 30% à fábrica.",
  "pts.process.4.t": "Produção",
  "pts.process.4.b": "A YANRE fabrica e prepara seus equipamentos.",
  "pts.process.5.t": "70% Antes do Envio",
  "pts.process.5.b": "O saldo final é quitado antes do embarque, conforme o contrato oficial.",
  "pts.process.6.t": "Envio",
  "pts.process.6.b": "Logística internacional coordenada para o seu projeto.",
  "pts.process.7.t": "Pós-Venda",
  "pts.process.7.b": "Suporte com respaldo da fábrica após a instalação.",
  "pts.monetize.label": "Monetize as Horas Vagas do Estúdio",
  "pts.monetize.h2a": "Faça seu estúdio trabalhar",
  "pts.monetize.h2b": "mesmo quando você não está.",
  "pts.monetize.copy": "Seu estúdio não precisa gerar valor apenas quando você treina seus próprios clientes. As horas vagas podem se tornar uma oportunidade de receita adicional, dando a outros Personal Trainers acesso ao seu espaço de treinamento profissional.",
  "pts.monetize.clients": "Seus Clientes",
  "pts.monetize.clientsSub": "Suas próprias sessões de treino",
  "pts.monetize.hours": "Horas Disponíveis",
  "pts.monetize.hoursSub": "Outros treinadores usam seu estúdio",
  "pts.monetize.revenue": "Mais Uma Fonte de Receita",
  "pts.monetize.revenueSub": "Aproveite melhor seu espaço ao longo do dia",
  "pts.monetize.closeA": "O estúdio é seu.",
  "pts.monetize.closeB": "Você controla a agenda.",
  "pts.form.label": "Comece Seu Projeto de Estúdio",
  "pts.form.h2a": "Conte para nós sobre",
  "pts.form.h2b": "seu estúdio.",
  "pts.form.sub": "Dois minutos. Um especialista responde com uma proposta concreta de equipamentos para o seu espaço e orçamento.",
  "pts.form.intro.sub1": "4 PASSOS RÁPIDOS.",
  "pts.form.intro.sub2": "UMA SOLUÇÃO COMPLETA PARA SEU ESTÚDIO.",
  "pts.form.intro.support": "Conte para nós sobre o seu estúdio em apenas 4 passos simples. Nossa equipe vai entender suas necessidades e ajudar você a construir a solução certa — com fornecimento direto da fábrica da YANRE FITNESS China, consultoria profissional e suporte pós-venda.",
  "pts.form.intro.minute": "1 MINUTO PARA CONCLUIR",
  "pts.form.progress": "Etapa",
  "pts.form.back": "Voltar",
  "pts.form.continue": "Continuar",
  "pts.form.submit": "Receber Meu Projeto de Estúdio",
  "pts.form.sending": "Enviando…",
  "pts.form.err.step": "Preencha os campos obrigatórios para continuar.",
  "pts.form.err.submit": "Algo deu errado ao enviar seu projeto. Tente novamente.",
  "pts.success.title": "Seu projeto de estúdio foi recebido.",
  "pts.success.body": "Um especialista YANRE vai analisar suas informações e entrar em contato para conversar sobre seu estúdio, necessidades de equipamentos e próximos passos.",
  "pts.success.reference": "Referência",
  "pts.success.cta": "Visitar a YANRE FITNESS",
  "pts.q.areYou": "O que melhor descreve você?",
  "pts.q.planning": "O que você está planejando?",
  "pts.q.package": "Qual pacote de estúdio interessa a você?",
  "pts.q.location": "Você já tem um espaço?",
  "pts.q.size": "Tamanho aproximado do estúdio:",
  "pts.q.timeline": "Quando você pretende inaugurar seu studio?",
  "pts.q.investment": "Qual é o seu orçamento de investimento estimado? (USD)",
  "pts.q.needs": "Do que você precisa?",
  "pts.q.needsHint": "Selecione todas as opções que se aplicam.",
  "pts.q.country": "País",
  "pts.q.city": "Cidade",
  "pts.q.fullName": "Nome Completo",
  "pts.q.email": "E-mail",
  "pts.q.phone": "Telefone / WhatsApp",
  "pts.q.company": "Empresa / Nome do Estúdio (opcional)",
  "pts.q.selectCountry": "Selecione o país",
  "pts.step.1": "Estúdio",
  "pts.step.2": "Espaço",
  "pts.step.3": "Investimento",
  "pts.step.4": "Contato",
  "pts.step.5": "Necessidades de Equipamentos",
  "pts.step.6": "Contato",
  "pts.opt.role.personal-trainer": "Personal Trainer",
  "pts.opt.role.sc-coach": "Treinador de Força e Condicionamento",
  "pts.opt.role.studio-owner": "Dono de Estúdio",
  "pts.opt.role.investor-entrepreneur": "Investidor / Empreendedor",
  "pts.opt.role.other": "Outro",
  "pts.opt.plan.first-studio": "Abrir meu primeiro estúdio",
  "pts.opt.plan.upgrade-studio": "Melhorar meu estúdio atual",
  "pts.opt.plan.another-location": "Abrir outra unidade",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "Preciso de ajuda para escolher",
  "pts.opt.loc.confirmed": "Sim",
  "pts.opt.loc.looking": "Ainda procurando",
  "pts.opt.loc.not-yet": "Ainda não",
  "pts.opt.size.under-50": "Menos de 50 m²",
  "pts.opt.size.50-100": "50–100 m²",
  "pts.opt.size.100-200": "100–200 m²",
  "pts.opt.size.over-200": "Mais de 200 m²",
  "pts.opt.size.undefined": "Ainda não definido",
  "pts.opt.time.1-2": "1–2 meses",
  "pts.opt.time.2-4": "2–4 meses",
  "pts.opt.time.4-6": "4–6 meses",
  "pts.opt.time.6-plus": "Mais de 6 meses",
  "pts.opt.inv.under-10k": "Menos de 10.000",
  "pts.opt.inv.10-20k": "10.000–20.000",
  "pts.opt.inv.20-40k": "20.000–40.000",
  "pts.opt.inv.40-80k": "40.000–80.000",
  "pts.opt.inv.80k-plus": "Mais de USD 80.000",
  "pts.opt.need.complete-studio-equipment": "Equipamento Completo de Estúdio",
  "pts.opt.need.strength": "Máquinas de Musculação",
  "pts.opt.need.functional": "Treino Funcional",
  "pts.opt.need.cardio": "Equipamentos de Cardio",
  "pts.opt.need.full-project-help": "Preciso de ajuda com o projeto completo",
  "pts.opt.role.gym-owner-operator": "Dono / Operador de Academia",
  "pts.opt.inv.under-20k": "Menos de USD 20.000",
  "pts.opt.inv.20-30k": "USD 20.000–30.000",
  "pts.opt.inv.30-50k": "USD 30.000–50.000",
  "pts.opt.inv.50-80k": "USD 50.000–80.000",
  "err.phoneInvalid": "Digite um número de telefone válido para o país selecionado.",
};
